// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610232205/js/" + chunkId + "." + {"44":"99ba23e6","225":"aca52d17","481":"cea57b3f","486":"183900d9","770":"13e9d8b3"}[chunkId] + ".0.03990863427620783.chunk.js";
};